const ApolloClient = require('apollo-client').default;
const http = require('http');
const { createHttpLink } = require('apollo-link-http');
const { InMemoryCache } = require('apollo-cache-inmemory');

const getGraphQLFragmentMatcher = require('./getGraphQLFragmentMatcher');

/**
 * Get the GraphQL Client for server
 * @param {Express.Request} req
 * @param {string} host
 * @param {string} path
 * @param {string} name
 * @param {string} version
 * @returns {ApolloClient} ApolloClient
 * @memberof module:@sm/utils
 */
const getGraphQLClientForServer = (req, host, path, name, version) => {
  const uri = `${host}${path}`;
  const link = createHttpLink({
    uri,
    credentials: 'include',
    headers: {
      cookie: req.header('Cookie')
    },
    fetch,
    fetchOptions: {
      agent: new http.Agent()
    }
  });

  const cache = new InMemoryCache({
    fragmentMatcher: getGraphQLFragmentMatcher()
  });

  return new ApolloClient({
    ssrMode: true,
    link,
    cache,
    name,
    version
  });
};

module.exports = getGraphQLClientForServer;
